import { useQuery } from '@apollo/client';
import orderBy from 'lodash/orderBy';
import { GET_COUNTRIES_QUERY } from '../graphql/queries';

const useCountries = () => {
  const countriesResponse = useQuery(GET_COUNTRIES_QUERY);

  return {
    countries: orderBy(countriesResponse.data?.countries ?? [], 'label', 'asc'),
    ...countriesResponse,
  };
};

export default useCountries;
